export const initialCoreState = {
  appKey: null,
  settings: {},
  isLoading: false,
  isDrawerOpen: false,
};

export const coreActions = {
  setIsLoading: isLoading => ({
    type: 'SET_IS_LOADING',
    isLoading,
  }),
  setIsDrawerOpen: isDrawerOpen => ({
    type: 'SET_IS_DRAWER_OPEN',
    isDrawerOpen,
  }),
  setSettings: settings => ({
    type: 'SET_SETTINGS',
    settings,
  }),
  toggleIsDrawerOpen: () => ({
    type: 'TOGGLE_IS_DRAWER_OPEN',
  }),
  updateSetting: (key, value) => ({
    type: 'UPDATE_SETTING',
    setting: { key, value },
  }),
};

export default (state, action) => {
  switch (action.type) {
    case 'SET_IS_LOADING':
      return { ...state, isLoading: action.isLoading };
    case 'SET_IS_DRAWER_OPEN':
      return { ...state, isDrawerOpen: action.isDrawerOpen };
    case 'SET_SETTINGS':
      return { ...state, settings: action.settings };
    case 'TOGGLE_IS_DRAWER_OPEN':
      return { ...state, isDrawerOpen: !state.isDrawerOpen };
    case 'UPDATE_SETTING':
      return { ...state, settings: { ...(state.settings ?? {}), [action.key]: action.value } };
    default:
      return { ...state };
  }
};
